module.exports = __webpack_public_path__ + "cd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/cd.svg
// module id = 482
// module chunks = 0